import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=97838f8a&scoped=true&"
import script from "./Footer.vue?vue&type=script&lang=javascript&"
export * from "./Footer.vue?vue&type=script&lang=javascript&"
import style0 from "./Footer.vue?vue&type=style&index=0&id=97838f8a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97838f8a",
  null
  
)

export default component.exports